import Storefront from 'utils/storefront';
import * as queries from 'utils/storefront/queries';
import { edgesToNodes, mergeProduct } from 'utils/storefront/format-resource';

export const getLinkedProduct = async (tag) => {
  const storefront = Storefront.getInstance();
  const response = await storefront.request({
    query: queries.productsByTagGet,
    variables: {
      query: `tag:"${tag}"`,
    },
  });

  if (response?.data?.products) {
    const products = edgesToNodes(response.data.products, 'product');
    return {
      product: mergeProduct(products),
      products,
    };
  }
  return null;
};
